import { useEffect, useState } from "react";
import { Container, Dropdown, Button, Modal } from "react-bootstrap";
import "./header.css";
import { Profile_Icon, starBadge, reward_logo } from "../../../assets/images";
import { checkUser } from "../../../axios/login.axios";
import { message } from "antd";
import TranslateWidget from "../../TranslateWidget";
const Header = () => {
  const [show, setShow] = useState(false);
  const [user] = useState(
    localStorage.getItem("userDetails")
      ? JSON.parse(localStorage.getItem("userDetails"))
      : null,
  );
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [clientDetails, setClientDetails] = useState(null);
  const logout = async () => {
    let afterLogout = localStorage.getItem("afterLogout");
    localStorage.clear();
    localStorage.setItem("afterLogout", afterLogout);
    message.warning("You are being logged out. Please wait...");
    window.open("/logout", "_self");
  };

  useEffect(() => {
    if (user) {
      checkUser(user.id)
        .then((resp) => {
          if (!resp.data.status) logout();
        })
        .catch((err) => {
          message.warning("something went wrong. Please wait...");
        });

      const clientDetails = JSON.parse(localStorage.getItem("clientDetails"));
      setClientDetails(clientDetails);
    }
  }, [user]);

  return (
    <div className="header_partttss">
      <Container fluid>
        <div className="header_inner">
          <div className="header_logo">
            <a href="/">
              <img
                width={250}
                height={75}
                style={{ objectFit: "contain" }}
                src={clientDetails?.corporateClientLogo || reward_logo}
                alt="logo"
              />
            </a>
          </div>
          <div className="header_user">
            <div className="prf_iconnn">
              <TranslateWidget />
              <Dropdown>
                <Dropdown.Toggle
                  className="user_drop"
                  variant="default"
                  id="dropdown-basic"
                >
                  <div className="user_drop_icon">
                    <img
                      src={Profile_Icon}
                      alt="Profile"
                      width={45}
                      height={45}
                    />
                    {user?.isStarBenifit && (
                      <span className="user_badge">
                        <img
                          width={20}
                          height={20}
                          src={starBadge}
                          alt="Badge"
                        />
                      </span>
                    )}
                  </div>
                  <span className="userdrop_name">
                    Welcome, {user ? user.name : ""}!
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="#/action-1" onClick={handleShow}>
                    Log Out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </Container>
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Body>
          <div className="modal_close">
            <h3>Are you sure you want to logout?</h3>
            <Button
              variant="secondary"
              onClick={handleClose}
              className="close_buuut"
            ></Button>
          </div>
        </Modal.Body>
        <Modal.Footer className="footer_but">
          <Button variant="secondary" onClick={logout} className="yesbut">
            Yes
          </Button>
          <Button variant="primary" onClick={handleClose} className="nobut">
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Header;
